module.exports = "<template>\r\n    ${fullName}\r\n</template>\r\n";